// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content-module--wrapper--25lTx"};